import {
  FiClock,
  FiShield,
  FiDollarSign,
  FiAward,
  FiMapPin,
  FiCheckCircle
} from "react-icons/fi";

import { motion } from "framer-motion";
import "./WhyChooseUs.css";


function WhyChooseUs() {


  const reasons = [

    {
      icon:<FiClock />,
      title:"Fast Emergency Response",
      text:"Our local locksmith team is available 24/7 to respond quickly when you need help most."
    },

    {
      icon:<FiShield />,
      title:"Trusted Security Experts",
      text:"Professional locksmith solutions delivered with care, experience, and attention to detail."
    },

    {
      icon:<FiDollarSign />,
      title:"Honest Pricing",
      text:"Clear communication and upfront pricing with no unnecessary surprises."
    },

    {
      icon:<FiAward />,
      title:"Quality Workmanship",
      text:"Reliable repairs, replacements, and security upgrades built to last."
    }

  ];



  const stats = [

    {
      number:"24/7",
      label:"Emergency Availability"
    },

    {
      number:"30 min",
      label:"Average Response"
    },

    {
      number:"100%",
      label:"Customer Focus"
    },

    {
      number:"5★",
      label:"Service Quality"
    }

  ];



return (

<section className="why" >

<div className="container">


<motion.div

className="why-header"

initial={{opacity:0,y:30}}

whileInView={{opacity:1,y:0}}

viewport={{once:true}}

>

<span>
WHY CHOOSE US
</span>


<h2>
Reliable Locksmith Services When It Matters Most
</h2>


<p>
We combine professional skills, modern security solutions,
and fast response times to protect homes, vehicles,
and businesses across Cape Town.
</p>


</motion.div>




<div className="why-grid">


{
reasons.map((item,index)=>(

<motion.div

className="why-card"

key={index}

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

viewport={{
once:true
}}

transition={{
delay:index * .15
}}

>


<div className="why-icon">

{item.icon}

</div>


<h3>
{item.title}
</h3>


<p>
{item.text}
</p>


<div className="check">
<FiCheckCircle/>
 Verified Service
</div>


</motion.div>


))
}


</div>





<div className="stats">


{
stats.map((stat,index)=>(

<motion.div

className="stat"

key={index}

initial={{
opacity:0,
scale:.8
}}

whileInView={{
opacity:1,
scale:1
}}

viewport={{
once:true
}}

transition={{
delay:index*.15
}}

>

<h3>
{stat.number}
</h3>

<p>
{stat.label}
</p>


</motion.div>

))
}


</div>


</div>

</section>


)

}


export default WhyChooseUs;